module.exports = __webpack_public_path__ + "static/media/SPRAY-BG2.b4f3ed5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/SPRAY-BG2.png
// module id = 279
// module chunks = 0